import { API } from 'aws-amplify';
import env from './config';
const { REALM } = env;

export interface ResponseOK<T> {
  result: 'ok';
  payload: T;
}
export interface ResponseNG {
  result: 'ng';
  message: string;
  code: number;
  cloudOriginalError: null;
}
export type Response<T> = ResponseOK<T> | ResponseNG;

export async function invoke<T>(o: {
  lambdaName: string;
  method?: string;
  pathParams?: { [param: string]: string; },
  queryParams?: { [param: string]: string; },
  recordId?: string,
  body?: any,
  payload?: { [param: string]: any }
}): Promise<T> {
  const payload = Object.assign({
    response: false,
    httpMethod: (o.method || '').toUpperCase(),
    pathParameters: o.pathParams,
    queryStringParameters: o.queryParams,
    body: JSON.stringify(o.body),
    realm: REALM,
  }, o.payload);
  const res = await API.post(o.lambdaName, '', { body: payload });
  if (res.statusCode !== 200) {
    return Promise.reject(new Error(o.lambdaName + ' returns ' + res.StatusCode));
  }
  if (typeof res.FunctionError === 'string') {
    return Promise.reject(new Error(o.lambdaName + ' ' + res.FunctionError + ' ' + res.Payload));
  }
  if (typeof res.body !== 'string') {
    return Promise.reject(new Error(o.lambdaName + ' does not return string body'));
  }
  if (typeof JSON.parse(res.body) !== 'object') {
    //this case is a primitive payload like a string
    return Promise.resolve(JSON.parse(res.body));
  }
  const ret: Response<T> = JSON.parse(res.body);
  if (ret.result !== 'ok') {
    const defaultMessage = `${ret.code} ${ret.message}`;
    console.warn(o.lambdaName, o, defaultMessage, res);
    return Promise.reject(new Error(defaultMessage));
  }
  return Promise.resolve(ret.payload);
}

export const sleep = (m: number) => new Promise(r => setTimeout(r, m));
